import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Loader } from '../utils/loader/Loader';
import './servicesarea.scss';
import video1 from "../../video/DebtModule.mp4";
import video2 from "../../video/EquityAnalytics.mp4";
import video3 from "../../video/FundScreener.mp4";
import video4 from "../../video/Treasury.mp4";

type props = {}

export const ServicesArea = (props: any) => {

    const [isOnline, setIsOnline] = useState(false);

    useEffect(() =>

        setIsOnline(true), [setIsOnline]
        
    );

    if (isOnline === false) {

        return <Loader />;
    }
    else
        return <div className="service_area">
            <video className="videoClass" controls loop src={video1}  />
            <video className="videoClass" controls loop src={video2} />
            <video className="videoClass" controls loop src={video3} />
            <video className="videoClass" controls loop src={video4} />
        <div className="container">
            <div className="row">
                <div className="col-xl-12">
                    <div className="section_title text-center mb-50">
                        <h2>Esplora le nostre soluzioni...</h2>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-4 col-md-4">
                    <div className="single_service service_bg_1">
                        <div className="service_hover">
                            <img src="img/svg_icon/legal-paper.svg" alt="" />
                            <h3>MARKET CONNECT WEB</h3>
                            <div className="hover_content">
                                <div className="hover_content_inner">
                                    <h4>-</h4>
                                        <p>Scopri di più su questo prodotto</p>
                                        <Link onClick={() => {

                                            props.clickhandler("Market Connect Web")
                                        }
                                        }
                                            to={'/Service'} className="nav-link"> MORE... </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-md-4">
                    <div className="single_service service_bg_2">
                        <div className="service_hover">
                            <img src='img/svg_icon/case.svg' alt="" />
                                <h3>INFRONT PROFESSIONAL TERMINAL</h3>
                                <div className="hover_content">
                                    <div className="hover_content_inner">
                                        <h4>-</h4>
                                        <p>Scopri di più su questo prodotto</p>
                                        {/* <li><Link onClick={() => {

                                            props.clickhandler("itp")
                                        }
                                        }
                                            to={'/Service'} className="nav-link"> MORE... </Link></li> */}
                                        <a className="nav-link" rel="noopener noreferrer" href="https://www.infrontfinance.com/products/professional-terminal/professional-terminal/" target="_blank">MORE...</a>
                                            
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-md-4">
                    <div className="single_service service_bg_3">
                        <div className="service_hover">
                            <img src="img/svg_icon/survey.svg" alt="" />
                                <h3>MARKET CONNECT FEED</h3>
                                <div className="hover_content">
                                    <div className="hover_content_inner">
                                        <h4>-</h4>
                                        <p>Scopri di più su questo prodotto</p>
                                        <Link onClick={() => {

                                            props.clickhandler("Market Connect Feed")
                                            }
                                        }
                                        to={'/ServiceServices'} className="nav-link"> MORE... </Link>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}


